import React, { useState, useEffect, PropTypes } from "react"
import Select from 'react-select';
import { Dropdown, ButtonGroup } from "react-bootstrap";
import { Col, Container, Row, Form } from 'react-bootstrap';
import $ from "jquery";
import qs from "qs"
import { isMobile, browserName, isTablet } from "react-device-detect";
import axios from 'axios';

import Breadcrumb from "../components/Home/Breadcrumb/Breadcrumb";
import SearchPage from "../components/SearchResult/SearchResult";
import SearchFilterBox from "../components/SearchBlock/SearchFilter";
import LoadmorePagination from "../components/SearchResult/LoadmorePagination"
import LoadPagination from "../components/SearchResult/LoadPagination"
import LoadpreviousPagination from "../components/SearchResult/LoadpreviousPagination"

//import MapResultsDesktop from "../components/map/search-results-desktop-map";
import SeoResults, { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr } from "../components/property-search/seoResults"

import MapImg from "../images/map.jpg"
import _ from "lodash"
import PropertyCard from "../components/PropertyCard/PropertyCard"
import PropertyCardGrid from "../components/PropertyCard/PropertyCardGrid";

import image from "../images/property-image.jpg"
import IncludeSold from "../components/search/filterSold"
import CurrConvertLayout from "../components/currency-converter/CurrConvertLayout"
import "./scss/search-template.scss";
import algoliasearch from "algoliasearch/lite"
import {
  parseSearchUrl,
  propertyH1,
  savedSearchParams
} from "../components/property-search/utils";
import {
  connectStats,
  SortBy,
  connectHits,
  connectInfiniteHits,
  InstantSearch,
  RefinementList,
  connectSearchBox,
  connectMenu,
  connectRange,
  Configure,
  ToggleRefinement,
  connectSortBy,
  connectAutoComplete,
  ClearRefinements,
  Menu,
  Pagination,
  connectPagination,
  RangeInput
} from "react-instantsearch-dom"
import {
  GoogleMapsLoader,
  GeoSearch,
  Marker,
  CustomMarker
} from 'react-instantsearch-dom-maps'
import Cookies from 'universal-cookie'
import { Link } from "@StarberryUtils";
import { navigate } from "@reach/router"
import { Helmet } from "react-helmet";
import { useLocation } from "@reach/router";
import { ListIcon, GridIcon } from "../components/Icons/Icons";

import MapResultsDesktop from "../components/map/search-results-desktop-map";


const mycookies = new Cookies();
const updateAfter = 500

var minpriceval = minpriceval || ""
var maxpriceval = maxpriceval || ""
var bedRoomval = 0
var property_finder_show = false;
const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_API_KEY
)

const index_name = `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`

let arrow = false
let filter = false
let totalHits = 0;

// Property results loop
const InfiniteHits = ({
  hits,
  view,
  hasPrevious,
  refinePrevious,
  hasMore,
  refineNext,
  location,
  tag,
  userObjects
}) => {
  return(
  <>
    {
      hits.length > 0 && hits.map((hit, i) => {

        // property details url structure
        let uriStr = "";
        let mysale = "";

        if (hit.search_type === "sales" && hit.department === 'residential') {
          uriStr = `properties-for-sale/`
          mysale = `myResSaleProp`
        }
        else if (hit.search_type === "lettings" && hit.department === 'residential') {
          uriStr = `properties-for-rent/`
          mysale = `myResRentProp`
        }
        else if (hit.search_type === "sales" && hit.department === 'commercial') {
          uriStr = `commercial-properties-for-sale/`
          mysale = `myComSaleProp`
        }
        else if (hit.search_type === "lettings" && hit.department === 'commercial') {
          uriStr = `commercial-properties-for-rent/`
          mysale = `myComRentProp`
        }
        // property details url structure
        
        const propMinPrice = hits.reduce((minPrice, hit) => {
          return hit.price < minPrice ? hit.price : minPrice;
        }, hits[0].price);
        
        const propMaxPrice = hits.reduce((maxPrice, hit) => {
          return hit.price > maxPrice ? hit.price : maxPrice;
        }, hits[0].price);
        if (typeof window !== 'undefined') {
          localStorage.setItem('propMinPrice', propMinPrice)
          localStorage.setItem('propMaxPrice', propMaxPrice)
        }
        const PropertyCardComponent = view === 'grid' ? PropertyCardGrid : PropertyCard;

        return (
          <Col 
              key={hit.objectID} 
              xs={12} 
              md={view === 'grid' ? 6 : 12} 
              lg={view === 'grid' ? 4 : 12} 
              className='col-xxl-custom'
            >
          <div className={`${view === 'grid' ? 'property-card-grid' : 'property-card'} mysingleproperty`} id={`${mysale}${hit.objectID}`} data-objectid={hit.objectID} data-lat={hit?._geoloc?.lat} data-lng={hit?._geoloc?.lng}>
            <Link onClick={() => mycookies.set(mysale, hit.objectID, { path: '/', maxAge: 300 })}
              to={`/${uriStr}${hit.slug.replace(/\//g, '').replace(/_/g, "-").replace(/#/g, "-")}-${hit.objectID}`}
              propID={hit.objectID}
            >
              
              <PropertyCardComponent
                images={hit.images}
                IntroText={hit.short_description}
                BedCount={hit.bedroom}
                BathCount={hit.bathroom}
                ReceptionCount={hit.reception}
                areaNumber={hit.floor_area || hit.floorarea_min}
                //areaSup={hit.areaSup}
                PropertyPrice={hit.price}
                PropertyHeading={hit.title}
                PropertyLocation={hit.area}
                PropertyBuilding={hit.county}
                unique_key={hit.objectID}
                status={hit.status}
                poa={hit.poa}
                tag={tag}
                noResult={false}
                department={hit.department}
                PropertyAddress={hit.address.Address}
                PropertyArea={hit.address.area}
                PropertyTown={hit.address.town}
                PropertyNegotiator={hit.negotiator_details}
              //videoid = {hit.vidoeId}
              />
            </Link>
          </div>
          </Col>
        )
      })
    }
  </>)
}

const CustomInfiniteHits = connectHits(InfiniteHits)
// Property results loop



// Custom Pagination
const CustomPagination = ({
  nbPages, 
  location
}) => {  
  var url_main = typeof window !== "undefined" ? window.location.pathname : ""
  var page =
  url_main.split("/").filter(c => c.includes("page-")).length > 0
    ? url_main
        .split("/")
        .filter(c => c.includes("page-"))[0]
        .split("page-")
        .map(c => c)[1]
    : 1;
 
  return (
    <>
     {totalHits > 12 &&
      <div className="algolia-pagination">
        <LoadpreviousPagination total={totalHits} current_page_number={parseInt(page)} number_of_pages={nbPages} location_path={location} />
        <LoadPagination total={totalHits}  current_page_number={parseInt(page)} number_of_pages={nbPages} location_path={location} />
        <LoadmorePagination total={totalHits} current_page_number={parseInt(page)} number_of_pages={nbPages} location_path={location} /> 
      </div>
    } 
    </>
   
  ) 
}

const CustomPaginationRender = connectPagination(CustomPagination)

// Searchbox
const SearchBox = connectSearchBox(({ currentRefinement, refine }) => {
  return (
    <div className="filter-search">
      <div className="filter-search-field filter-search-area">
        <i class="search-icon"></i>
        <Form.Control type="text" placeholder="Building, Area or Project name" id="formBasicEmail"
          onChange={event => refine(event.currentTarget.value.replace(/,/g, " ").replace(/'/g, "").replace(/\s+/g, ' ').toLowerCase())}
          value={currentRefinement.replace(/-/g, ' ')}
        />
      </div>
    </div>
  )
})
// Searchbox



// Property Bedrooms
const bedroomSelectBox = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
}) => {

  let bedroomvalselect = ""
  if (currentRefinement.max !== undefined) {
    bedroomvalselect = 0
  } else if (currentRefinement.min !== undefined) {
    bedroomvalselect = currentRefinement.min
  }
  let options = [
    { value: "", label: "Any" },
    { value: '1', label: '1 +' },
    { value: '2', label: '2 +' },
    { value: '3', label: '3 +' },
    { value: '4', label: '4 +' },
    { value: '5', label: '5 +' },
    { value: '6', label: '6 +' },
    { value: '7', label: '7 +' },
    { value: '8', label: '8 +' },
    { value: '9', label: '9 +' }
  ]
  return (
    <Select
      name="beds"
      options={options}
      // value={{ label: bedroomvalselect ? options.filter(c => c.value == bedroomvalselect)[0].label : "Beds", value: bedroomvalselect ? bedroomvalselect : "" }} value={{ label: bedroomvalselect ? options.filter(c => c.value == bedroomvalselect)[0].label : "Beds", value: bedroomvalselect ? bedroomvalselect : "" }}
      placeholder="Beds"
      classNamePrefix={"select-opt"}
      onChange={(e) => {
        if (e.value === "") {
          refine(e.value, e.label)
        } else {
          refine({
            min: e.value
          })
        }
      }}
    />

  )
}

const CustombedroomSelectbox = connectRange(bedroomSelectBox)
// Property Bedrooms

// Property type
const buildingSelectbox = ({ items, currentRefinement, refine }) => (
  <Select
    name="building"
    options={[
      { value: "", label: "All" },
      { value: "Apartment", label: "Apartment" },
      { value: "Villa", label: "Villa" },
      { value: "Townhouse", label: "Townhouse" },
      { value: "Penthouse", label: "Penthouse" },
      { value: "Land", label: "Land" },
      { value: "Plot", label: "Plot" },
      { value: "Full Floor", label: "Full floor" },
      { value: "Hotel Apartment", label: "Hotel/Hotel Apartment" },
      // { value: "shop", label: "Shop" }
      // { value: "property", label: "Others" },
    ]}
    value={{ label: currentRefinement ? _.startCase(_.toLower(currentRefinement)) : "Property Type", value: currentRefinement ? currentRefinement : "" }}
    placeholder="Property Type"
    classNamePrefix={"select-opt"}
    onChange={(e) => { refine(e.value, e.label) }}
  />
)

const CustombuildingSelectbox = connectMenu(buildingSelectbox)
// Property type

//finder
const Finder = ({ items, createURL, refine, initLimit, attribute }) => {
 
  const [limit, setLimit] = useState(initLimit);
  useEffect(()=>{ 
    if(isMobile || isTablet){
      setLimit(items.length)
    }
  }, [items])

  if(attribute === "sub_finder"){
    property_finder_show = items.length > 0
  }
  let showMoreCount = items.length - limit; 
  return (
    <div className="block">
    {items.slice(0, limit).map(item => (
      <div className={`list ${item.isRefined ? 'active' : ''}`} onClick={() => { refine(item.value) }}>
        {item.label.replace(/-/g, ' ')}  <span className="count"> ({item.count})</span>
      </div>

    ))}
    {limit !== items.length && showMoreCount > 0 &&
        <div className={`list showmore`} onClick={()=>{setLimit(items.length)}}> +{showMoreCount} more</div>
    } 
  </div>
  )
} 
const CustomFinder = connectMenu(Finder);
//Building finder 

const customStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#005480" : null,
      color: isFocused ? "#ffffff" : "#575757"
    };
  },
  control: styles => ({
    ...styles,
    backgroundColor: null,
    border: 0,
    paddingLeft: 0,
    outline: 0,
    boxShadow: 'none',
    color: '#4c505b',
    fontSize: '1rem',
    fontWeight: '300',
    flexDirection: 'row-reverse'
  }),
  valueContainer: (styles) => ({
    ...styles,
    fontSize: '1rem',
    paddingLeft: 0,
    paddingRight: 0,
    lineHeight: '30px',
    fontWeight: '300',
    cursor: 'pointer'
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    //  color: "#ffffff",
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    // color: '#ffffff',
    padding: 0,
    cursor: 'pointer'
  }),
  indicatorSeparator: () => null,
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#4c505b',
      marginLeft: 0
    }
  },
}

// Dropdown react select styles

const CustomSortBy = ({ items, refine, currentRefinement }) => (
  <div className={`search-select-box search-select-dropdown ${currentRefinement} props_filter`}>
    <Select
      options={items}
      defaultValue={currentRefinement || ''}
      placeholder="Featured"
      value={_.find(items, function (o) { return (o.value === currentRefinement || o.value + "_beds" === currentRefinement) })}
      classNamePrefix={"select-opt"}
      isSearchable={false}
      onChange={(e) => {
        if (bedRoomval > 0) {
          refine(e.value + "_beds", e.label)
        } else {
          refine(e.value, e.label)
        }
      }}
      styles={customStyles}
    // /components={{ DropdownIndicator: () => <DownIndicator /> }}
    />
  </div>
);

const CustomSortByFilter = connectSortBy(CustomSortBy);

// Sort by




// No Results
const NoStats = ({ processingTimeMS, nbHits, hitsPerPage, propertyData, propertyTypeData, type, tag , view}) => {
  var data = propertyData.filter((x) => x.status != "Sold" && x.status != "Rented");
  if (type && propertyTypeData.length > 0) {
    data = propertyTypeData;
  }
  setTimeout(() => {
    if ($('#no-result').length >= 1) {
      $('.filtersearchsold').css('pointer-events', 'none');
      $('.props_filter').css('pointer-events', 'none');
    } else {
      $('.filtersearchsold').css('pointer-events', 'auto');
      $('.props_filter').css('pointer-events', 'auto');
    }
  }, 100)
  totalHits = nbHits
 

  return (
    <>
      {nbHits === 0 &&
        <>
          <Row>
            <Col lg={12} className="text-center mb-5" id="no-result">
              <h4>Unfortunately, we do not currently have any properties that match your search criteria.</h4>
              <p>We have selected some of our showcase properties for you to browse below. Alternatively, you can search again in the bar above.</p>
            </Col>
          </Row>
          {
            data && data.map((hit, i) => {

              // property details url structure
              let uriStr = "";
              let mysale = "";

              if (hit.search_type === "sales" && hit.department === 'residential') {
                uriStr = `properties-for-sale/`
                mysale = `myResSaleProp`
              }
              else if (hit.search_type === "lettings" && hit.department === 'residential') {
                uriStr = `properties-for-rent/`
                mysale = `myResRentProp`
              }
              else if (hit.search_type === "sales" && hit.department === 'commercial') {
                uriStr = `commercial-properties-for-sale/`
                mysale = `myComSaleProp`
              }
              else if (hit.search_type === "lettings" && hit.department === 'commercial') {
                uriStr = `commercial-properties-for-rent/`
                mysale = `myComRentProp`
              }
              // property details url structure
              const PropertyCardComponent = view === 'grid' ? PropertyCardGrid : PropertyCard;
              return (
                <Col 
                key={hit.objectID} 
                xs={12} 
                md={view === 'grid' ? 6 : 12} 
                lg={view === 'grid' ? 4: 12} 
                className='col-xxl-custom'
              >
                <div className={`${view === 'grid' ? 'property-card-grid' : 'property-card'} mysingleproperty`} id={`${mysale}${hit.id}`} data-objectid={hit.id} data-lat={hit?.latitude} data-lng={hit?.longitude}>
                  <Link onClick={() => mycookies.set(mysale, hit.id, { path: '/', maxAge: 300 })}
                    to={`/${uriStr}${hit.slug.replace(/\//g, '').replace(/_/g, "-").replace(/#/g, "-")}-${hit.id}`}
                    propID={hit.id}
                  >
                    <PropertyCardComponent
                      images={hit.images}
                      IntroText={hit.short_description}
                      BedCount={hit.bedroom}
                      BathCount={hit.bathroom}
                      ReceptionCount={hit.reception}
                      areaNumber={hit.floor_area || hit.floorarea_min}
                      //areaSup={hit.areaSup}
                      PropertyPrice={hit.price}
                      PropertyHeading={hit.title}
                      PropertyLocation={hit.address?.area}
                      PropertyBuilding={hit.address?.county}
                      unique_key={hit.id}
                      status={hit.status}
                      tag={tag}
                      noResult={true}
                      department={hit.department}
                      PropertyAddress={hit.address.Address}
                      PropertyArea={hit.address.area}
                      PropertyTown={hit.address.town}
                    //videoid = {hit.vidoeId}
                    />
                  </Link>
                </div>
                </Col>
              )
            })}

        </>
      }
    </>
  )
}

const CustomNoStats = connectStats(NoStats)
// No Results

// Results count
const Stats = ({ processingTimeMS, nbHits }) => <>{nbHits}</>

const CustomStats = connectStats(Stats)
// Results count


// Create URL
export const createURL = (props, state, location) => {
  let myarea = state.menu

  const isDefaultRoute =
    !state.query &&
    !state.SortBy &&
    state.page === 1 &&
    state.menu &&
    state.range &&
    !state.range.price &&
    !state.range.bedroom

  if (isDefaultRoute) {
    return ""
  }

  var areaPath = "in-dubai/"
  var bedroomPath = ""
  var pricePath = ""
  var pagePath = ""
  var propertypath = ""
  var amenitiesPath = ""  
  var sizePath = ""
  var finderPath = ""
  var subFinderPath = ""
  var sortPath = ""

  if (state.query) {
    if (state.query) {
      areaPath = "in-" + encodeURIComponent(decodeURIComponent(state.query.replace(/ /g, '-'))) + "/"
    }
  }

  const queryParameters = {}

  // Property path
  if (state.menu) {
    if (myarea["building"]) {
      propertypath = "type-" + _.toLower(myarea["building"]).replace(/ /g, '-') + "/"
    }
  }
  // Property path

   // property finder path
   if (state.menu) {
    if (myarea["finder"]) {
      finderPath = "finder-" + myarea["finder"] + "/"
    }
  }
  // property sub finder path
  if (state.menu) {
    if (myarea["sub_finder"]) {
      subFinderPath = "sub-area-" + myarea["sub_finder"] + "/"
    }
  }

 // Amenities path
  if (state.refinementList) { 
    if (typeof state.refinementList.amenities === "object") {
      if (state.refinementList.amenities.length > 0) {
        var amenities_list = state.refinementList.amenities.filter(function (item, index, inputArray) {
          return inputArray.indexOf(item) == index;
        });
        if (amenities_list.length > 0) {
          amenitiesPath = `with-${amenities_list.map(encodeURIComponent).join('-and-')}/`
        }
      }
    } else {
    //  amenitiesPath = `with-${state.refinementList.amenities}/`
    }

  }
  // Amenities path

  // Size
  if (state.range?.floor_area) {
    if (parseInt(state.range.floor_area.min) && parseInt(state.range.floor_area.max)) {
      sizePath = "size-" + state.range.floor_area.min + "-to-" + state.range.floor_area.max + '/' //queryParameters.price_min = state.range.price.min;
    } else if (parseInt(state.range.floor_area.max)) {
      sizePath = "belowsize-" + state.range.floor_area.max + '/' //queryParameters.price_max = state.range.price.max;
    } else if (parseInt(state.range.floor_area.min) && parseInt(state.range.floor_area.min) > 0) {
      sizePath = "abovesize-" + state.range.floor_area.min + '/' //queryParameters.price_max = state.range.price.max;
    }
  }
 
  // Bedrooms & Price range path
  if (state.range) {
    // Bedrooms
    if (state.range.hasOwnProperty('bedroom') && state.range.bedroom.max === 0) {
      bedroomPath = "studio/" //queryParameters.price_max = state.range.price.max;
    }
    if (state.range.bedroom) {
      if (state.range.bedroom.min) {
        bedroomPath = state.range.bedroom.min + "-and-more-bedrooms/" //queryParameters.price_max = state.range.price.max;
      }
    }

    // Price
    if (state.range.price) {
      if (state.range.price.min && state.range.price.max) {
        pricePath = "between-aed" + state.range.price.min + "-and-aed" + state.range.price.max + '/' //queryParameters.price_min = state.range.price.min;
      } else if (state.range.price.max) {
        pricePath = "below-aed" + state.range.price.max + '/' //queryParameters.price_max = state.range.price.max;
      } else if (state.range.price.min) {
        pricePath = "above-aed" + state.range.price.min + '/' //queryParameters.price_max = state.range.price.max;
      }
    }
  }
  // Bedrooms & Price range path

  // Sort path
  if (state.sortBy) {
    if (state.sortBy === index_name + "_price_asc" || state.sortBy === index_name + "_price_asc_beds") {
      sortPath = "sortby-price-asc/";
    }
    if (state.sortBy === index_name + "_price_desc" || state.sortBy === index_name + "_price_desc_beds") {
      sortPath = "sortby-price-desc/";
    }
    if (state.sortBy === index_name + "_newest" || state.sortBy === index_name + "_newest_beds") {
      sortPath = "sortby-newest/";
    }
    if (state.sortBy === index_name || state.sortBy === index_name + "_featured_beds") {
      sortPath = "";
    }

  }
  // Sort path

  // Page path
  if (state.page && state.page !== 1) {
    pagePath = `page-${state.page}/`
  }
  // Page path

  const queryString = qs.stringify(queryParameters, {
    addQueryPrefix: true,
    arrayFormat: "repeat",
  })

  let myUrl = `${areaPath}${propertypath}${finderPath}${subFinderPath}${bedroomPath}${pricePath}${amenitiesPath}${sizePath}${queryString}${pagePath}${sortPath}`

  // if ("/" === myUrl.substr(myUrl.length - 1))
  //   myUrl = myUrl.substr(0, myUrl.length - 1)

  return `${location}${myUrl}`
}
// Create URL

// URL to searchstate
const searchStateToUrl = (props, searchState, location) =>
  searchState ? `${createURL(props, searchState, location)}` : ""

const urlToSearchState = location => {

  if (location) {
    var query = ""
    let pathUri_main = ''

    let a1 = location.pathname.indexOf("/properties/for-sale") > -1
    let a2 = location.pathname.indexOf("/properties/for-rent") > -1
    if (a1 == true) {
      pathUri_main = location.pathname.split("/properties/for-sale")
    }
    else if (a2 == true) {
      pathUri_main = location.pathname.split("/properties/for-rent")
    }
    else {
      pathUri_main = location.pathname.split(location)
    }

    var areaVal = ""
    var bedVal = 10
    var minpriceVal = ""
    var maxpriceVal = ""
    var pageVal = ""
    var propertyval = ""
    var finderVal = ""
    var subFinderVal = ""
    var sortVal = ""
    var sortVal_filt = ""
    var negotiator = ""
    var amenitiesVal = ""
    var minsizeval = ""
    var maxsizeval = ""
    var poa = false;

    if (pathUri_main[1]) {
      // following could be regexp
      let pathUri = pathUri_main[1].split("/")

      // console.log("pathUri",pathUri);

      //lets loop
      for (let vi = 1; vi <= pathUri.length; vi++) {
        // check for area
        if (typeof pathUri[vi] === "undefined") {
          continue
        }

        // Property type
        if (pathUri[vi].indexOf("type-") >= 0) {
          propertyval = pathUri[vi].replace("type-", "")
        }
        // Property type
        if (pathUri[vi].indexOf("finder-") >= 0) {
          finderVal = pathUri[vi].replace("finder-", "")
        }
          // Property type
          if (pathUri[vi].indexOf("sub-area-") >= 0) {
            subFinderVal = pathUri[vi].replace("sub-area-", "")
          }

        // negotiator id
        if (pathUri[vi].indexOf("negotiator-") >= 0) {
          negotiator = pathUri[vi].replace("negotiator-", "")
        }

        // Area
        // if (
        //   pathUri[vi].indexOf("in-") >= 0 &&
        //   pathUri[vi] !== "finder-mbr-mohammad-bin-rashid" &&
        //   pathUri[vi] !== "finder-mohammed-bin-rashid-city"
        // ) {
        //   areaVal = pathUri[vi].replace("in-", "");
        // }
        if (
          pathUri[vi].indexOf("in-") >= 0 && pathUri[vi].includes("in-") &&
          pathUri[vi] !== "finder-mbr-mohammad-bin-rashid" &&
          pathUri[vi] !== "finder-mohammed-bin-rashid-city"
        ) {
          areaVal = pathUri[vi].replace("in-", "");
        } 

        // Price
        if (
          pathUri[vi].indexOf("between-aed") >= 0 ||
          pathUri[vi].indexOf("above-aed") >= 0 ||
          pathUri[vi].indexOf("below-aed") >= 0
        ) {
          poa = true;
          let priceFilt1 = pathUri[vi].split("above-aed")
          if (priceFilt1[1]) {
            minpriceVal = priceFilt1[1]
          }
          let priceFilt2 = pathUri[vi].split("below-aed")
          if (priceFilt2[1]) {
            maxpriceVal = priceFilt2[1]
          }
          let priceFilt3 = pathUri[vi].split("between-aed")
          if (priceFilt3[1]) {
            let priceFilt4 = priceFilt3[1].split("-and-aed")
            minpriceVal = priceFilt4[0]
            maxpriceVal = priceFilt4[1]
          }
        }

        // Amenities
        if (pathUri[vi].indexOf("with-") >= 0) {
          // its Amenities
          var amenitiesArrfilt = pathUri[vi].replace("with-", "")
          amenitiesVal = amenitiesArrfilt.split("-and-")
        }

        // Size
        if (
          pathUri[vi].indexOf("size-") >= 0 ||
          pathUri[vi].indexOf("abovesize-") >= 0 ||
          pathUri[vi].indexOf("belowsize-") >= 0
        ) {
          let priceFilt1 = pathUri[vi].split("abovesize-")
          if (priceFilt1[1]) {
            minsizeval = priceFilt1[1]
          }
          let priceFilt2 = pathUri[vi].split("belowsize-")
          if (priceFilt2[1]) {
            maxsizeval = priceFilt2[1]
          }
          let priceFilt3 = pathUri[vi].split("size-")
          if (priceFilt3[1]) {
            let priceFilt4 = priceFilt3[1].split("-to-")
            minsizeval = priceFilt4[0]
            maxsizeval = priceFilt4[1]
          }
        }

        // Bedrooms
        if (pathUri[vi].indexOf("-and-more-") >= 0) {
          bedVal = pathUri[vi].replace("-and-more-bedrooms", "")
        }

        if (pathUri[vi].indexOf("studio") >= 0) {
          // its studio bedroom
          bedVal = 0
        }



        // Sort by
        if (pathUri[vi].indexOf("sortby-") >= 0) {
          sortVal_filt = pathUri[vi].replace("sortby-", "")

          if (sortVal_filt === "price-asc") {
            sortVal = index_name + "_price_asc"
          }

          if (sortVal_filt === "price-desc") {
            sortVal = index_name + "_price_desc"
          }

          if (sortVal_filt === "newest") {
            sortVal = index_name + "_newest"
          }
          if (sortVal_filt === "featured") {
            sortVal = index_name + "_featured"
          }

        }

        // Page
        if (pathUri[vi].indexOf("page") >= 0) {
          pageVal = pathUri[vi].replace("page-", "")
        }
      }
    }
  }

  // Property type
  if (propertyval) {
    query += `&menu[building]=` + propertyval.replace(/-/g, ' ').toLowerCase()
  }

  //finder 
   if (finderVal) {
    query += `&menu[finder]=` + finderVal
  } 
  //sub finder 
  if (subFinderVal) {
    query += `&menu[sub_finder]=` + subFinderVal
  } 

  // Size 
  if (minsizeval) {
    query += `&range[floor_area][min]=` + minsizeval
  }
  if (maxsizeval) {
    query += `&range[floor_area][max]=` + maxsizeval
  }


  // negotiator
  if (negotiator) {
    query += `&refinementList[negotiator_id]=` + negotiator
  }

   // poa
  //  if (poa) {
  //   query += `&refinementList[poa]=N`
  // }


  // Area
  if (areaVal) {
    areaVal = areaVal.replace(/-/g, ' ').toLowerCase();
    if (areaVal == "dubai") query += `&query=`
    else query += `&query=` + areaVal
  }

  // Price
  if (minpriceVal) {
    query += `&range[price][min]=` + minpriceVal
  }

  if (maxpriceVal) {
    query += `&range[price][max]=` + maxpriceVal
  }

   // Amenities
   if (amenitiesVal) {
    for (let v = 0; v <= amenitiesVal.length; v++) {
      if (typeof amenitiesVal[v] !== "undefined") {
        query += `&refinementList[amenities]=` + amenitiesVal[v]
      }
    }
  }

  // Bedrooms
  if (bedVal == 0) {
    query += `&range[bedroom][min]=` + 0
  } else if (bedVal < 10) {
    query += `&range[bedroom][min]=` + bedVal
  }



  // Page
  if (pageVal) {
    query += `&page=${pageVal}`
  }

  // Sort by
  // if (sortVal) {
  //   query += `&sortBy=` + sortVal
  // } 
  bedRoomval = 0;
  if (bedVal > 0 && bedVal < 10) {
    bedRoomval = bedVal;
    if (sortVal) {
      query += `&sortBy=` + sortVal + "_beds"
    } else {
      query += `&sortBy=` + index_name + "_featured" + "_beds"
    }
  } else {
    if (sortVal) {
      query += `&sortBy=` + sortVal
    }
  }


  //console.log('llll', query)
  return qs.parse(query)
}
// URL to searchstate

// Min Price
const priceminRangeLetting = [{ "value": "0", "label": "No Min" }, { "value": "20000", "label": "20,000 AED" }, { "value": "30000", "label": "30,000 AED" }, { "value": "40000", "label": "40,000 AED" }, { "value": "50000", "label": "50,000 AED" }, { "value": "60000", "label": "60,000 AED" }, { "value": "70000", "label": "70,000 AED" }, { "value": "80000", "label": "80,000 AED" }, { "value": "90000", "label": "90,000 AED" }, { "value": "100000", "label": "100,000 AED" }, { "value": "110000", "label": "110,000 AED" }, { "value": "120000", "label": "120,000 AED" }, { "value": "130000", "label": "130,000 AED" }, { "value": "140000", "label": "140,000 AED" }, { "value": "150000", "label": "150,000 AED" }, { "value": "160000", "label": "160,000 AED" }, { "value": "170000", "label": "170,000 AED" }, { "value": "180000", "label": "180,000 AED" }, { "value": "190000", "label": "190,000 AED" }, { "value": "200000", "label": "200,000 AED" }, { "value": "225000", "label": "225,000 AED" }, { "value": "250000", "label": "250,000 AED" }, { "value": "275000", "label": "275,000 AED" }, { "value": "300000", "label": "300,000 AED" }, { "value": "350000", "label": "350,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "750000", "label": "750,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }]

const priceminRange = [{ "value": "0", "label": "No Min" }, { "value": "300000", "label": "300,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "600000", "label": "600,000 AED" }, { "value": "700000", "label": "700,000 AED" }, { "value": "800000", "label": "800,000 AED" }, { "value": "900000", "label": "900,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }, { "value": "1100000", "label": "1,100,000 AED" }, { "value": "1200000", "label": "1,200,000 AED" }, { "value": "1300000", "label": "1,300,000 AED" }, { "value": "1400000", "label": "1,400,000 AED" }, { "value": "1500000", "label": "1,500,000 AED" }, { "value": "1600000", "label": "1,650,000 AED" }, { "value": "1700000", "label": "1,700,000 AED" }, { "value": "1800000", "label": "1,800,000 AED" }, { "value": "1900000", "label": "1,900,000 AED" }, { "value": "2000000", "label": "2,000,000 AED" }, { "value": "2100000", "label": "2,100,000 AED" }, { "value": "2200000", "label": "2,200,000 AED" }, { "value": "2300000", "label": "2,300,000 AED" }, { "value": "2400000", "label": "2,400,000 AED" }, { "value": "2500000", "label": "2,500,000 AED" }, { "value": "2600000", "label": "2,600,000 AED" }, { "value": "2700000", "label": "2,700,000 AED" }, { "value": "2800000", "label": "2,800,000 AED" }, { "value": "2900000", "label": "2,900,000 AED" }, { "value": "3000000", "label": "3,000,000 AED" }, { "value": "3250000", "label": "3,250,000 AED" }, { "value": "3500000", "label": "3,500,000 AED" }, { "value": "3750000", "label": "3,750,000 AED" }, { "value": "4000000", "label": "4,000,000 AED" }, { "value": "4250000", "label": "4,250,000 AED" }, { "value": "4500000", "label": "4,500,000 AED" }, { "value": "5000000", "label": "5,000,000 AED" }, { "value": "6000000", "label": "6,000,000 AED" }, { "value": "7000000", "label": "7,000,000 AED" }, { "value": "8000000", "label": "8,000,000 AED" }, { "value": "9000000", "label": "9,000,000 AED" }, { "value": "10000000", "label": "10,000,000 AED" }, { "value": "25000000", "label": "25,000,000 AED" }, { "value": "50000000", "label": "50,000,000 AED" }]

const styles = {
  control: styles => ({ ...styles, backgroundColor: '#f7fbff', border: 0, outline: 0, boxShadow: 'none', fontSize: '14px', color: '#263140', minHeight: '3rem', paddingLeft: '1rem', marginBottom: '1rem' }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#263140',
    }
  }
}

const minpriceSelectbox = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
  type
}) => {
  var minPriceRange = priceminRange;
  minpriceval = currentRefinement.min
  if (type == "lettings") {
    minPriceRange = priceminRangeLetting;
  }
  if (currentRefinement.max !== undefined && currentRefinement.max != "0") {
    minPriceRange = minPriceRange.filter((x) => x.value == "0" || parseInt(x.value) < parseInt(currentRefinement.max))
  }
  return (
    <Select
      name="minprice"
      options={minPriceRange}
      defaultValue={currentRefinement.min || "0"}
      value={{ label: currentRefinement.min ? minPriceRange.filter(c => c.value == currentRefinement.min)[0].label : "Min Price", value: currentRefinement.min ? currentRefinement.min : "" }}
      placeholder="Minimum Price"
      onChange={(e) => {
        minpriceval = e.value
        if (e.value === "0") {
          if (maxpriceval) {
            refine({
              max: maxpriceval,
            })
          } else refine(e.value, e.label)
        } else {
          if (maxpriceval != "0") {
            refine({
              min: e.value,
              max: maxpriceval,
            })
          } else {
            refine({ min: e.value })
          }

        }
      }}
      //components={{ DropdownIndicator:() => <SelectArrow />, IndicatorSeparator:() => null }}
      styles={styles}
    />
  )
}

const CustomminpriceSelectbox = connectRange(minpriceSelectbox)
// Min Price

// Max Price
const pricemaxRangeLetting = [{ "value": "0", "label": "No Max" }, { "value": "20000", "label": "20,000 AED" }, { "value": "30000", "label": "30,000 AED" }, { "value": "40000", "label": "40,000 AED" }, { "value": "50000", "label": "50,000 AED" }, { "value": "60000", "label": "60,000 AED" }, { "value": "70000", "label": "70,000 AED" }, { "value": "80000", "label": "80,000 AED" }, { "value": "90000", "label": "90,000 AED" }, { "value": "100000", "label": "100,000 AED" }, { "value": "110000", "label": "110,000 AED" }, { "value": "120000", "label": "120,000 AED" }, { "value": "130000", "label": "130,000 AED" }, { "value": "140000", "label": "140,000 AED" }, { "value": "150000", "label": "150,000 AED" }, { "value": "160000", "label": "160,000 AED" }, { "value": "170000", "label": "170,000 AED" }, { "value": "180000", "label": "180,000 AED" }, { "value": "190000", "label": "190,000 AED" }, { "value": "200000", "label": "200,000 AED" }, { "value": "225000", "label": "225,000 AED" }, { "value": "250000", "label": "250,000 AED" }, { "value": "275000", "label": "275,000 AED" }, { "value": "300000", "label": "300,000 AED" }, { "value": "350000", "label": "350,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "750000", "label": "750,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }]

const pricemaxRange = [{ "value": "0", "label": "No Max" }, { "value": "300000", "label": "300,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "600000", "label": "600,000 AED" }, { "value": "700000", "label": "700,000 AED" }, { "value": "800000", "label": "800,000 AED" }, { "value": "900000", "label": "900,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }, { "value": "1100000", "label": "1,100,000 AED" }, { "value": "1200000", "label": "1,200,000 AED" }, { "value": "1300000", "label": "1,300,000 AED" }, { "value": "1400000", "label": "1,400,000 AED" }, { "value": "1500000", "label": "1,500,000 AED" }, { "value": "1600000", "label": "1,650,000 AED" }, { "value": "1700000", "label": "1,700,000 AED" }, { "value": "1800000", "label": "1,800,000 AED" }, { "value": "1900000", "label": "1,900,000 AED" }, { "value": "2000000", "label": "2,000,000 AED" }, { "value": "2100000", "label": "2,100,000 AED" }, { "value": "2200000", "label": "2,200,000 AED" }, { "value": "2300000", "label": "2,300,000 AED" }, { "value": "2400000", "label": "2,400,000 AED" }, { "value": "2500000", "label": "2,500,000 AED" }, { "value": "2600000", "label": "2,600,000 AED" }, { "value": "2700000", "label": "2,700,000 AED" }, { "value": "2800000", "label": "2,800,000 AED" }, { "value": "2900000", "label": "2,900,000 AED" }, { "value": "3000000", "label": "3,000,000 AED" }, { "value": "3250000", "label": "3,250,000 AED" }, { "value": "3500000", "label": "3,500,000 AED" }, { "value": "3750000", "label": "3,750,000 AED" }, { "value": "4000000", "label": "4,000,000 AED" }, { "value": "4250000", "label": "4,250,000 AED" }, { "value": "4500000", "label": "4,500,000 AED" }, { "value": "5000000", "label": "5,000,000 AED" }, { "value": "6000000", "label": "6,000,000 AED" }, { "value": "7000000", "label": "7,000,000 AED" }, { "value": "8000000", "label": "8,000,000 AED" }, { "value": "9000000", "label": "9,000,000 AED" }, { "value": "10000000", "label": "10,000,000 AED" }, { "value": "25000000", "label": "25,000,000 AED" }, { "value": "50000000", "label": "50,000,000 AED" }]

const maxpriceSelectbox = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
  type
}) => {
  let maxPriceRange = pricemaxRange;
  let maxpricedisable = ''
  maxpriceval = currentRefinement.max
  if (type == "lettings") {
    maxPriceRange = pricemaxRangeLetting;
  }

  if (currentRefinement.min !== undefined) {
    maxPriceRange = maxPriceRange.filter((x) => x.value == "0" || parseInt(x.value) > parseInt(currentRefinement.min))
  }
  if (currentRefinement.min == "30000000") {
    maxpricedisable = 'disabled'
  }

  return (
    <Select
      name="maxprice"
      options={maxPriceRange}
      defaultValue={currentRefinement.max || "0"}
      value={{ label: currentRefinement.max ? maxPriceRange.filter(c => c.value == currentRefinement.max)[0].label : "Max Price", value: currentRefinement.max ? currentRefinement.max : "" }}
      placeholder="Maximum Price"
      onChange={(e) => {
        maxpriceval = e.value
        if (e.value === "0") {
          if (minpriceval) {
            refine({
              min: minpriceval,
            })
          } else refine(e.value, e.label)
        } else {
          if (minpriceval != "0") {
            refine({
              min: minpriceval,
              max: e.value,
            })
          } else {
            refine({ max: e.value })
          }
        }
      }}
      //components={{ DropdownIndicator:() => <SelectArrow />, IndicatorSeparator:() => null }}
      styles={styles}
    />
  )
}

const CustommaxpriceSelectbox = connectRange(maxpriceSelectbox)
// Max Price

const strapiconfig = {
  headers: {
      Authorization:
          `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
  },
}

class PropertySearchSales extends React.Component {

  constructor(props) {
    super(props);
    this.wordToNumber = {
      'ONE': 1,
      'TWO': 2,
      'THREE': 3,
      'FOUR': 4,
      'FIVE': 5,
    };
  }


  // 
  state = {
    searchState: urlToSearchState(typeof window !== 'undefined' ? window.location : ''),
    view: "list",
    userObjects: [],
    noResultProperty: [],
    noResultPropertyTypeData: [],
    negoDetails: [],
    mycurr: 'AED',
    includeSoldinside: false,
    includeLetinside: false
  }

  toggleView = (view) => this.setState({ view });
  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.setState({ searchState: urlToSearchState(this.props.location) }, () => {
        //console.log("searchState =>", this.state.searchState)
        var nego_id = this.state.searchState?.refinementList?.negotiator_id;
        if(nego_id){
          this.getNegoName(nego_id);
        } else{
          this.setState({negoDetails:[]})
        }

      })
    }
  }

  onSearchStateChange = searchState => {

    clearTimeout(this.debouncedSetState)
    this.debouncedSetState = setTimeout(() => {
      navigate(searchStateToUrl(this.props, searchState, this.props.locationname), searchState)
    }, updateAfter)
    if (searchState?.menu?.building != this.state.searchState?.menu?.building) {
      this.getitemstwo(searchState?.menu?.building)
    }
    this.setState({ searchState })
  }

  includeSoldclick = e => {
    this.setState({
      includeSoldinside: !this.state.includeSoldinside
    })
  }

  includeLetclick = e => {
    this.setState({
      includeLetinside: !this.state.includeLetinside
    })
  }

  // Map view
  mapView = (e) => {
    navigate(this.props.location.pathname.replace("properties", "properties-map"))
  }

  // Search filter text
  searchFilterText = (e) => {
    $(".search_text").toggleClass("active")
    $(".search-result-short").toggleClass("searchText")
  }

  handleCurrConvert = (childData) =>{
      this.setState({mycurr: childData})
  }

  onSearchStateChange2 = (searchState) => {
    this.setState({ searchState })
  }

  getitemsone = async url => {
    try {
      const { data } = await axios.get(url, strapiconfig)
      this.setState({ noResultProperty: data })
    } catch (error) {
      console.error(error)
    }
  }
  getReviews = async (url) => {
    try {
      const { data } = await axios.get(url, strapiconfig);

      this.setState({ reviewCount: data.length });
      const sumOfScores = data.reduce((sum, review) => {
        const reviewStringValue = review.starRating;
        return sum + this.wordToNumber[reviewStringValue];
      }, 0);

      const averageRating = Math.round((sumOfScores / data.length) * 10) / 10;
      this.setState({ averageRating });
    } catch (error) {
      console.error('Error fetching reviews:', error);
    }
  };
  getitemstwo = async (building) => {
    let url1 = process.env.GATSBY_STRAPI_SRC + "/properties?search_type=" + this.props.ptype + "&_limit=8&_sort=published_at:DESC&publish=true&department=" + this.props.pcategorytype + "&[building_contains]=" + building; // TODO: base URL supposed to be from .env
    try {
      const { data } = await axios.get(url1, strapiconfig)
      this.setState({ noResultPropertyTypeData: data })
    } catch (error) {
      console.error(error)
    }
  }

  getNegoName = async (nego_id) => {
    //console.log("nego_id =>", nego_id)
    let url1 = process.env.GATSBY_STRAPI_SRC + "/peoples?reapit_code="+nego_id.toUpperCase()+"&_limit=1"; 

    // TODO: base URL supposed to be from .env
    try {
      const { data } = await axios.get(url1, strapiconfig)
      this.setState({ negoDetails: data })
    } catch (error) {
      console.error(error)
    }
  }



  componentDidMount() {
    this.getReviews(`${process.env.GATSBY_STRAPI_SRC}/google-review-reviews`);

    var nego_id = this.state.searchState?.refinementList?.negotiator_id;
    if(nego_id){
      this.getNegoName(nego_id);
    }
    
    $(document).mouseup(function (e) {
      var container = $(".price-filter-dropdown");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".price-filter-dropdown").removeClass("active");
      }
    });

    window.addEventListener("scroll", this.handleScroll, true)

    // load on top
    $(document).ready(function () {
      $("html, body").scrollTop(0);
    });
    // load on top

    // 
    $(".property_sortby_asc").click(function () {
      $(".property_sortby_asc").addClass("active");
      $(".property_sortby_desc").removeClass("active");
    })

    $(".property_sortby_desc").click(function () {
      $(".property_sortby_desc").addClass("active");
      $(".property_sortby_asc").removeClass("active");
    })
    //

    // Sold filter
    $(".filtersearchsold").insertAfter(".defaultsoldfilter");
    // Sold filter

    // iPhone input fields zoom fix
    $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1.0, shrink-to-fit=no, maximum-scale=1.0, user-scalable=0">');
    // iPhone input fields zoom fix

    //No result property 
    let url = process.env.GATSBY_STRAPI_SRC + "/properties?search_type=" + this.props.ptype + "&_limit=8&_sort=published_at:DESC&publish=true&department=" + this.props.pcategorytype + "&featured_property=Y"; // TODO: base URL supposed to be from .env

    this.getitemsone(url)
    if (this.state.searchState?.menu?.building) {
      this.getitemstwo(this.state.searchState?.menu?.building)
    }

     //filter show/hide
   
      if(!this.state.searchState?.menu?.building){ 
        $(".finder-list-building").addClass("show");
        $(".finder-list-building").removeClass("hide");  
      }else{ 
        $(".finder-list-building").removeClass("show");
        $(".finder-list-building").addClass("hide");
      }
      if(this.state.searchState?.menu?.building){
        $(".finder-list-finder").removeClass("hide");
        $(".finder-list-finder").addClass("show");
      }else{
        $(".finder-list-finder").removeClass("show");
        $(".finder-list-finder").addClass("hide");
      }
      // if(this.state.searchState?.menu?.building && this.state.searchState?.menu?.finder && property_finder_show){
      //   $(".finder-list-sub-finder").removeClass("hide");
      //   $(".finder-list-sub-finder").addClass("show");
      // }else{
      //   $(".finder-list-sub-finder").removeClass("show");
      //   $(".finder-list-sub-finder").addClass("hide");
      // }
    

  }


  render() {
    const {view, reviewCount, averageRating} = this.state;
    //console.log("negoDetails =>",this.state.negoDetails);
    const searchState = {...this.state.searchState}

    const arrowClick = () => {
      arrow = true
    }
    const handlerClick = () => {
    }

    //
    const clickHandle = (e) => {
      const li = e.target.closest('li');
      li.closest('ul').querySelectorAll('li').forEach(item => {
        if (item !== li) {
          item.classList.remove('active');
        }
      })
      e.target.closest('li').classList.toggle('active');
    }

    const capitalize = (s) => {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    }

    var nego_name = ""
    if(this.state.negoDetails?.length > 0){
      nego_name = this.state.negoDetails[0].Name
    }


    let minPrice = typeof window !== 'undefined' ? localStorage.getItem('minPrice') : null
    let maxPrice = typeof window !== 'undefined' ? localStorage.getItem('maxPrice') : null

    const searchParams = parseSearchUrl(this.props.ptype, this.props.fullpathname ,minPrice, maxPrice);

    const saveSearchParams = savedSearchParams(searchParams);

    var meta_title = propertyH1(searchParams, false);
    var search_title = propertyH1(searchParams, false);
    if(nego_name && searchParams?.pType == "sales"){
      meta_title = `Sales Properties Managed by ${nego_name}`;
    }
    if(nego_name && searchParams?.pType == "lettings"){
      meta_title = `Rental Properties Managed by ${nego_name}`;
    }
    var replace = meta_title.replace(/Properties for rent in /g, "");
    //var h1 = meta_title.includes("rent") ? `${replace} Rental Properties` : meta_title;
    var h1 = meta_title
    if(searchParams.type === "apartment" && searchParams.areas === "jumeirah beach residence"){
      h1 = "Apartments for sale in Jumeirah Beach Residence (JBR)"
    }
    //console.log("h1",h1)
    //var title = meta_title.includes("sale") ? ` | Apartments & Villa for Sale ` : ` | Apartments & Villa for Rent`;
    //h1 += title;
    
    const introH1 = propertyH1(searchParams, true);
    //console.log(searchParams.pType,"introH1")
    const areaName =  _.startCase(_.capitalize(searchParams.areas));  

    const pType = searchParams.pType;
    
    let propertyType = "";
    if (searchParams.type == "") {
      propertyType = "properties "
    } else {
      var typeReplace = searchParams.type
      switch (searchParams.type) {
        case "apartment":
          typeReplace = "apartments";
          break;
        case "villa":
          typeReplace = "villas";
          break;
        case "townhouse":
          typeReplace = "townhouses";
          break;
        case "penthouse":
          typeReplace = "penthouses";
          break;
        case "land":
          typeReplace = "lands";
          break;
        case "plot":
          typeReplace = "plots";
          break;
        case "full-floor":
          typeReplace = "full-floors";
          break;
        case "hotel-apartment":
          typeReplace = "hotel-apartments";
          break;
      }
      propertyType = typeReplace;
    }

    const actionStr = ACTION_TYPES[pType];
    const actionDescStr = ACTION_DESC_TYPES[pType];
    var meta_description = ""
    if(searchParams.type === "" && pType === "lettings" && searchParams.areas === "dubai"){
      meta_description = `Looking for properties for rent in Dubai? Explore top-notch living spaces with luxurious amenities and prime locations. Find your dream property today! Rent properties in Dubai with ease.`
    }else if(searchParams.type === "" && pType === "sales" && searchParams.areas === "palm jumeirah"){
      meta_description = `Explore luxurious properties for sale in Palm Jumeirah. Find your dream home in one of Dubai's most prestigious locations. Browse listings now!`
    }else if(searchParams.type === "" && pType === "sales" && searchParams.areas === "dubai marina"){
      meta_description = `Explore a wide range of properties for sale in Dubai Marina with Dacha Real Estate. From waterfront residences to luxury amenities, find your dream home in our listings today!`
    }else if(searchParams.type === "townhouse" && pType === "lettings" && searchParams.areas === "Dubai"){
      meta_description = `Dacha Real Estate presents top-notch townhouses for rent in Dubai. Browse our listings and rent the perfect home that meets your needs and desires in Dubai.`
    }else if(introH1.includes("sale")) {
      meta_description = `Find ${introH1}. View thousands of houses for sale in Dubai on our website and get an amazing deal. Find your dream home with Dacha Real Estate now!`
    }else{
      meta_description = `Apartment, Flat, & Villas for Rent in ${replace}: Looking for ${introH1}? Try Dacha Real Estate. We help you with all your property needs.`
    }

    // var meta_description = introH1.includes("sale") ?
    //             `Find ${introH1}. View thousands of houses for sale in Dubai on our website and get an amazing deal. Find your dream home with Dacha Real Estate now!`
    //           :
    //             `Apartment, Flat, & Villas for Rent in ${replace}: Looking for ${introH1}? Try Dacha Real Estate. We help you with all your property needs.`

    var description = meta_description;
    //console.log("introh1",introH1,searchParams)
    if(searchParams.type){
      if(searchParams.type === "apartment" && searchParams.areas === "jumeirah beach residence"){
        description = `Looking for apartments for sale in Jumeirah Beach Residence. Explore top-notch living spaces with luxurious amenities and prime locations. Find your dream property today! Buy apartments in Jumeirah Beach Residence with ease.`
      }else if(searchParams.type === "townhouse" && searchParams.areas === "Dubai"){
        description = `Dacha Real Estate presents top-notch townhouses for rent in Dubai. Browse our listings and rent the perfect home that meets your needs and desires in Dubai.`
      }else{
         description = `Looking for ${introH1}. Explore top-notch living spaces with luxurious amenities and prime locations. Find your dream property today! ${pType === "lettings" ? "Rent" : "Buy"} ${searchParams.type}s in ${areaName} with ease.`
      }
    }
    if (searchParams.price.min || searchParams.price.max) {
      description = `Discover the range of ${introH1}. Book an appointment with one of our property experts in ${areaName}.`
    }
    if (searchParams.bedrooms) {
      description = `Browse through ${introH1}. Check here for the finest collection of ${areaName} properties.`
    }
    if ((searchParams.price.min || searchParams.price.max) && searchParams.type) {
      description = `Find the collection of ${introH1} here. Dacha real estate offers a wide range of ${(propertyType)}${actionStr}${areaName}.`
    }
    if ((searchParams.price.min || searchParams.price.max) && searchParams.bedrooms) {
      description = `Find ${introH1} with Dacha Real Estate. Contact us for more details about properties in ${areaName}.`
    }
    if (searchParams.type && searchParams.bedrooms) {
      description = `Discover the best ${introH1}. Contact Dacha, the leading real estate agents in ${areaName}.`
    }
    if ((searchParams.price.min || searchParams.price.max) && searchParams.type && searchParams.bedrooms) {
      description = `Check out ${introH1} with Dacha Real Estate. Our property experts help you find the perfect ${(propertyType)} in ${areaName}.`
    }

    var intoCopy = `Search for ${introH1} with Dacha Real Estate. Refine your search using the filters above and for more information about ${(propertyType)} in ${areaName}, Please `



    const isPageLoadBg = (typeof this.props.fullpathname === "undefined");
    if(nego_name && searchParams?.pType =='sales'){
      description = `Explore sales properties managed by ${nego_name}. Find your ideal home or investment with trusted guidance every step of the way.`;
    }
    if(nego_name && searchParams?.pType =='lettings'){
      description = `Browse rental properties managed by ${nego_name}. Quality homes with reliable support to match your lifestyle and budget.`;
    }
    // Geo toggle tablet & mobile
    const geoPinClick = (e) => {
      $(".property_map_pin").removeClass("active");
      $(".property_map_list").addClass("active");

      $(".property_list_results").addClass("d-none");
      $(".right-side").removeClass("mobile-none");
    }

    const geoToggleClick = (e) => {
      $(".property_map_list").removeClass("active");
      $(".property_map_pin").addClass("active");

      $(".property_list_results").removeClass("d-none");
      $(".right-side").addClass("mobile-none");
    }
    // Geo toggle tablet & mobile

    const filterRefine = (e) => {
      $(".filter-section").removeClass("refine");
      $("#filter-one").hide();
      $("#filter-two").show();
    }
    const filterRefineone = (e) => {
      $(".filter-section").addClass("refine");
      $("#filter-one").show();
      $("#filter-two").hide();
    }

    var defaultStatus = this.state.includeSoldinside ? ["For Sale", "Sold"] : ["For Sale"];
    if (this.props.ptype === "lettings") {
      defaultStatus = this.state.includeLetinside ? ["To Let", "Rented"] : ["To Let"];
    }

    let language = typeof window !== 'undefined' ? localStorage.getItem('language') : null

    let mystatus = ''
    if(defaultStatus){
      if(Array.isArray(defaultStatus)){
        mystatus = '(status:"'+(defaultStatus).join('" OR status:"')+'")'
      } else {
        mystatus = '(status:"'+(defaultStatus)+'")'
      }
    }

    const logoBlue = `${process.env.GATSBY_SITE_URL}/images/logo-blue.svg`;

    const propminimumPrice = typeof window !== 'undefined' ? localStorage.getItem('propMinPrice') : null
    const propmaxPrice = typeof window !== 'undefined' ? localStorage.getItem('propMaxPrice') : null
    const sParamType= searchParams.type ? searchParams.type.charAt(0).toUpperCase() + searchParams.type.slice(1) + "s" : "Properties";
    return (
      <>
      {propminimumPrice && propmaxPrice && (
      <Helmet>
                <script type="application/ld+json">{`{
                   "@context" : "http://schema.org",
                    "@type" : "Product",
                    "name" : "${sParamType}${actionDescStr}in ${searchParams.areas}",
                    "image": "${logoBlue}",
                    "description" : "${description}",
                    "brand" : {
                          "@type" : "Organization",
                          "name" : "Dacha Real Estate"
                      },
                    "aggregateRating": {
                          "@type": "AggregateRating",
                          "ratingValue": "${averageRating}",
                          "reviewCount": "${reviewCount}"
                      },

                    "offers": {
                          "@type": "AggregateOffer",
                          "lowPrice": ${propminimumPrice},
                          "highPrice": ${propmaxPrice},
                          "priceCurrency": "AED"
                          }
                      }
          `}</script>
                
        </Helmet>)}
        
      <div className={`${language === 'Russian' ? 'russian-class' : ''} wrapper search-result-page search-result-orange one search-result-${view}-wrap`}>

        {!isPageLoadBg &&
          <SeoResults title={h1} searchParams={searchParams} description={description} location={this.props.location} pcategorytype={this.props.pcategorytype} />
        }
        <div className="filtersearchsold">
          <IncludeSold
            searchState={this.state.searchState}
            ptype={this.props.ptype}
            searchClient={searchClient}
            indexName={index_name}
            createURL={createURL}
            onSearchStateChange={this.onSearchStateChange2}
            includeSoldclick={this.includeSoldclick}
            includeSoldinside={this.state.includeSoldinside}
            includeLetclick={this.includeLetclick}
            includeLetinside={this.state.includeLetinside}
          />
        </div>

        <InstantSearch
          indexName={index_name}
          searchClient={searchClient}
          searchState={this.state.searchState}
          onSearchStateChange={this.onSearchStateChange}
          createURL={createURL}
          routing="true"
        >
          <div className="d-none">
            {/* <RefinementList
              attribute="search_type"
              defaultRefinement={[this.props.ptype]}
            />
            <RefinementList
              attribute="department"
              defaultRefinement={[this.props.pcategorytype]}
            />
            <RefinementList
              attribute="status"
              defaultRefinement={defaultStatus}
            /> */}
          </div>
          <Configure
          filters={`publish:true AND search_type:${this.props.ptype} AND department:${this.props.pcategorytype} AND ${mystatus}`} 
            hitsPerPage={12}
          />
          <Container fluid>
            <Row>
              <Col xl={12} id="search_results_list" className="pr-xl-0 search-results-main">
                <div className={filter ? "filter-section " : "filter-section"}>
                  {/* <div className="filter-section-heading d-xl-none refine-search">
                    <div onClick={filterRefine} id="filter-one" className="refine-filter">Refine Your Search <i className="icon-angle-down-big-white ml-3"></i></div>
                    <div onClick={filterRefineone} id="filter-two" className="refine-filter">Refine Your Search <i className="icon-angle-down-big-white ml-3"></i></div>
                  </div> */}
                  <div className="submit-filters-box submit-filters-field">
                    <Container>
                      <SearchFilterBox type={this.props.ptype} searchState={this.state.searchState} currecy={this.state.mycurr}  locationname={this.props.locationname}/>
                    </Container>
                  </div>
                  <div className="filter-group  d-none d-none-searchbox">
                    <SearchBox />

                    <div className="filter-select">
                      <div className="filter-select-field">
                        <ul className="filter-list">
                          <li className="price-filter-dropdown">
                            <button type="button" onClick={clickHandle}>Price Range</button>
                            <div className="filter-dropdown">
                              <div className="select">
                                <CustomminpriceSelectbox attribute="price" type={this.props.ptype} />
                              </div>
                              <div className="select">
                                <CustommaxpriceSelectbox attribute="price" type={this.props.ptype} />
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="filter-select-field filter-select-width">
                        <CustombedroomSelectbox attribute="bedroom" />
                      </div>

                      <div className="filter-select-field">
                        <CustombuildingSelectbox attribute="building" />
                        <RefinementList attribute="negotiator_id" />
                        <RefinementList attribute="poa" />
                        <RefinementList attribute="amenities" /> 
                        <RangeInput attribute="floor_area" /> 
                      </div>
                    </div>
                  </div>
                  {/* <ClearRefinements
                      transformItems={items =>
                        items.filter(({ attribute }) => !["search_type", "department"].includes(attribute))
                      }
                      translations={{
                        reset: 'Clear all',
                      }}
                    /> */}
                  <Container>
                    <div className="search-result-short">

                      <div className="search-result-title">
                        {/* <h4 className="h1">{search_title}<strong>(<CustomStats />) <a href="javascript:void(0)" onClick={this.searchFilterText}><i className="info-icon"></i></a></strong></h4> */}
                        <h1 className="">{meta_title}<strong>(<CustomStats />) <a href="javascript:void(0)" onClick={this.searchFilterText}><i className="info-icon"></i></a></strong></h1>
                      </div>

                      <div className="filter-short d-flex align-items-center">
                        <div className="search-select-box search-select-box-dropdown">
                          <CurrConvertLayout parentCallback = {this.handleCurrConvert} outterClass="currency_select"/>
                        </div>
                        <div className="switch-button property-filter_check defaultsoldfilter d-none">
                          {/* {this.props.ptype === "sales" ?
                            <ToggleRefinement
                              attribute="status"
                              label="Include Sold"
                              value={['Sold']}
                            /> :
                            <ToggleRefinement
                              // attribute="status"
                              label="Include Let"
                              value={['Rented']}
                            />
                          } */}
                        </div>

                        <CustomSortByFilter
                          className="search-sory-by"
                          items={[
                            { value: index_name + "_newest", label: "Newest" },
                            { value: index_name + "_price_desc", label: "Highest Price" },
                            { value: index_name + "_price_asc", label: "Lowest Price" },
                            { value: index_name, label: "Featured" },
                          ]}

                          defaultRefinement={`${index_name}`}
                        />
                        <div className="view-switch">
                            <button 
                              onClick={() => this.toggleView(view === 'list' ? 'grid' : 'list')} 
                              className="text-xs"
                            >
                               <span className="list-grid-icon">{view === 'list' ?<GridIcon /> : <ListIcon />}</span> <span>{view === 'list' ? 'Grid View' : 'List View'}</span>
                            </button>
                        </div>
                        <div onClick={this.mapView} className="map-icon-wrapper mapview">
                          <i className="map-icon"></i> <span class="map-text">View on</span> Map
                        </div>
                        
                      </div>
                    </div>
                    <p className="desc d-none search_text">{intoCopy.replace(/-/g, ' ')} <Link to="/contact/">contact Dacha real estate.</Link></p>
                    <div className={`finder-list finder-list-building ${(!searchParams.type)? 'show' : 'hide'}`}>
                      <CustomFinder attribute="building" initLimit={5} />
                    </div>
                    <div className={`finder-list finder-list-finder ${(searchParams.type)? 'show' : 'hide'}`}>
                        <CustomFinder attribute="finder"  initLimit={5} />
                    </div>
                  </Container>
                  {/* <div className={`finder-list finder-list-sub-finder ${(searchParams.type && searchParams.finder && property_finder_show)? 'show' : 'hide'}`}>
                      <CustomFinder attribute="sub_finder" initLimit={5}  />
                  </div>
                   */}
                </div>
              
                <div className="property-card-list property_list_results" id="property_list_results">
                  <Container className="px-md-0">
                    <div className="row">
                      <CustomInfiniteHits mycurr={this.state.mycurr} location={this.props.fullpathname} tag={this.props.ptypetag} view={view} />
                      <CustomNoStats propertyData={this.state.noResultProperty} propertyTypeData={this.state.noResultPropertyTypeData} tag={this.props.ptypetag} type={this.state.searchState?.menu?.building} view={view} />
                     
                    </div>
                  </Container>
                  {totalHits > 0 && (
                      <div className="load-more-wrap">
                          <Container>
                          <CustomPaginationRender location={this.props.fullpathname} />
                          </Container>
                        </div>
                    )}
                </div>
              </Col> 
            </Row>
          </Container>
        </InstantSearch>
      </div>
      </>
    )
  }
}

export default PropertySearchSales
